import React from 'react';

import { IonItem, IonList } from '@ionic/react';

import Typography from 'components/Typography';
import { DateRangeFormatter } from 'intl';
import IOStatus from 'scenes/FinancePage/IO/Details/components/Status';

export default ({ data = [], isBudgetOverrun = false }: any) => {
  return (
    <IonList className={'io-list'}>
      {data.map((row: any) => {
        const dateRange = [row.period?.from, row.period?.to];
        return (
          <IonItem
            key={row.id}
            button={false}
            lines={'full'}
            className={'padding-top padding-bottom'}
            // detail={true}
            // routerLink={`/${FINANCE}/io/${row.id}/details`}
            // routerDirection={'root'}
          >
            <div>
              <div>
                <Typography variant={'subtitle1'} color={'primary'}>
                  {row?.businessEntities?.map((el: any) => el.name).join(', ')}
                </Typography>
              </div>
              <div>
                <Typography>
                  <DateRangeFormatter value={dateRange} template={'MONTH'} />
                </Typography>
              </div>
              {isBudgetOverrun ? (
                <Typography color={'danger'} variant={'caption'}>
                  Add an amendment to IO approved by the legal team
                </Typography>
              ) : null}
            </div>
            <div slot={'end'}>
              <IOStatus value={row?.status} />
            </div>
          </IonItem>
        );
      })}
    </IonList>
  );
};
